var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZipIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3069_9466)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.57129 8.28577C8.57129 6.07663 10.3622 4.28577 12.5713 4.28577H30.857L39.4284 12.8572V39.7143C39.4284 41.9235 37.6376 43.7143 35.4284 43.7143H12.5713C10.3622 43.7143 8.57129 41.9235 8.57129 39.7143V8.28577Z",
    fill: "url(#paint0_linear_3069_9466)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.8568 12.8572L39.4282 12.8572L30.8568 4.28575L30.8568 10.8572C30.8568 11.9617 31.7522 12.8572 32.8568 12.8572Z",
    fill: "#9271D6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.5711 21.4286H21.4282V28.2857H26.5711V21.4286ZM24.8568 22.2857H23.1425V24.8572H24.8568V22.2857ZM26.5711 30H23.9997V31.7143H21.4282V33.4286H23.9997V35.1429H21.4282V36.8572H23.9997V38.5714H21.4282V40.2857H23.9997V42H21.4282V43.7143H23.9997V42H26.5711V40.2857H23.9997V38.5714H26.5711V36.8572H23.9997V35.1429H26.5711V33.4286H23.9997V31.7143H26.5711V30Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3069_9466",
    x1: 23.9999,
    y1: 43.7143,
    x2: 23.9999,
    y2: 4.28577,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9271D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A40BF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3069_9466"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZipIcon);
export default __webpack_public_path__ + "static/media/zip-icon.fd6303434b7bbb87060a175e6a65ec04.svg";
export { ForwardRef as ReactComponent };